import React from 'react';
import { Sequence, AbsoluteFill } from 'remotion';
import { ThemeSystemConfig } from '../../clipCreator/remotion/Components/Theme/Theme';
import { AspectRatio } from '../AspectRatio';
import { TimelineDefaults } from '../TimelineDefaults';
import { MediaObject } from '../media/types';
import { LayerItem } from './base';

export interface BackgroundItem extends LayerItem {
    mediaObject: MediaObject;
}

export class BackgroundItemImpl implements BackgroundItem {
    id: string;
    startAt: number;
    duration?: number;
    mediaObject: MediaObject;

    constructor(background: Omit<BackgroundItem, 'render'>) {
        this.id = background.id;
        this.startAt = background.startAt;
        this.duration = background.duration;
        this.mediaObject = background.mediaObject;
    }

    render(fps: number, theme: ThemeSystemConfig, aspectRatio: AspectRatio, defaults: TimelineDefaults): React.ReactNode {
        const sequenceProps = {
            key: this.id,
            name: `Background-${this.id}-${this.startAt}s-${this.duration || 'infinite'}s`,
            from: Math.round(this.startAt * fps),
            ...(this.duration && this.duration > 0 ? { durationInFrames: Math.round(this.duration * fps) } : {})
        };

        return (
            <Sequence {...sequenceProps}>
                <AbsoluteFill>
                    {this.mediaObject.render(fps, this.id, this.duration ?? 0)}
                </AbsoluteFill>
            </Sequence>
        );
    }
} 